import type { FC } from 'react'
import { Icon } from '@matillion/component-library'
import classes from './FinishedTestRow.module.scss'

export interface StartTimeProps {
  startTime: Date
}

export const StartTime: FC<StartTimeProps> = ({ startTime }) => {
  return (
    <>
      <Icon.Play className={classes.FinishedTestRow__Icon} />
      <span>{startTime.toLocaleString()}</span>
    </>
  )
}
